import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, Params } from '@angular/router';
import {MdSnackBar,MdSnackBarConfig,MdDialog, MdDialogRef} from '@angular/material';
import { FormBuilder, Validators,FormArray,FormControl } from '@angular/forms';
import { ListingService } from '../admin/listing.service';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-adminpack-upgrade',
  templateUrl: './adminpack-upgrade.component.html',
  styleUrls: ['./adminpack-upgrade.component.css'],
  providers:[ListingService]
})
export class AdminpackUpgradeComponent implements OnInit {
    detail:any=[];
  eventId:any=0;
  eventUserId:any=0;
  errorMessage : any;
  spinner: boolean = false;
  packageList :any=[];
  package:any;
cheksub=1;
  constructor(public dialogRef: MdDialogRef<AdminpackUpgradeComponent>, private formBuilder: FormBuilder, private ListingService: ListingService,private snackBar: MdSnackBar,private pageTitle: Title,private router: Router) { }

  ngOnInit() {
    this.getPackageList();
    this.package= {
      package: '',
    }

  }
  close() {
    this.dialogRef.close();
  }
  getPackageList(){
    this.spinner = true;
    this.ListingService.getPackageList({eventId:this.eventId,amount:(this.detail.detail[0].packagePrice>0?this.detail.detail[0].packagePrice:0)}).subscribe(
            response => {
          //this.spinner = false;
          this.packageList = response.package;

        },
            error => {
          this.spinner = false;
          this.errorMessage = <any>error;
          this.snackBar.open('something went wrong','',{duration:4000});
        }
    );
  }

  phoneFormat(phone) {
    if (phone && phone != '')
      return (phone).replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  }

  packChanged(){

    if(this.package.package){
      let sindex = this.packageList.findIndex(d => d.id === this.package.package)
      let pack=this.packageList[sindex];
      //console.log(pack.price-this.detail.detail[0].packagePrice);
      this.package.balance=pack.price-this.detail.detail[0].packagePrice>0?pack.price-this.detail.detail[0].packagePrice:0;
      //console.log(this.package.balance);
    }
  }


  upgradeUser(upgradeForm){

    if (upgradeForm.valid && this.package.balance>0 && this.cheksub==1) {
        this.cheksub=0
      this.ListingService.upgradeUser({ packId:this.package.package, balance: this.package.balance, eventUserId: this.eventUserId, eventId: this.eventId,userId: this.detail.detail[0].userId}).subscribe(
              response => {
            this.spinner = false;
            if (response.status==true) {
                this.cheksub=1
              this.snackBar.open('Registration Upgrade is Successful!', '', { duration: 4000 });
              this.dialogRef.close(response.status);
            }
            else{
                this.cheksub=1
                this.snackBar.open(response.msg, '', { duration: 4000 });
            }

          },
              error => {
                  this.cheksub=1
            this.spinner = false;
          }
      );
    }
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/adminpack-upgrade/adminpack-upgrade.component.ts